import { createApp, nextTick } from 'vue'
import App from './delegate-header.vue'
import { ZmContext, ZmButton } from '@zoom/zoom-ui-vue3'

import { DOM_IDS } from './constants.js'
import { createMobileWatcher } from './responsive.js'
import { mountMobileToggle, unmountMobileToggle } from './sub-apps/mount-mobile-toggle.js'
import { createAppI18n } from '../../../shared/setup-i18n'
export default function initCommonHeader() {
  const target = document.getElementById(DOM_IDS.HEADER_CONTAINER)

  const i18n = createAppI18n('commonHeader')
  const app = createApp(App)
  app.use(i18n)
  app.use(ZmContext)
  app.use(ZmButton)
  app.mount(target)

  nextTick(() => {
    createMobileWatcher({
      onEnter: mountMobileToggle,
      onLeave: unmountMobileToggle
    }).start()
  })
}
